import styled, { css } from 'styled-components';
import { ColorTheme, getTheme } from '../utils/colorTheme';
import { Colors } from '../utils/colors';

export const Content = styled.div<{ reverse?: boolean, image?: string, imagePosition?: string, removeExcessPadding?: boolean }>`
    width: 50%;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    padding: 100px 0;
    align-items: baseline;

    ${(p) => p.image && css`
        background-image: url(${p.image});
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        align-content: center;
        min-height: 300px;

        @media screen and (max-width: 600px){
            min-height: 30vw;
        }
    `}

    ${(p) => p.imagePosition && css`
        background-position: ${p.imagePosition};
    `}

    @media screen and (max-width: 600px){
        padding: 50px 0 !important;
    }

    ${(p) => p.removeExcessPadding && css`
        @media screen and (max-width: 900px) {
            padding-top: 0 !important;
        }
    `}

    &:first-child {
        justify-content: end;
    }

    &:last-child {
        justify-content: start;
    }
`;

export const Container = styled.div<{ reverse?: boolean, verticallyCenter?: boolean }>`
    max-width: 720px;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    ${(p) => p.verticallyCenter && css `
        align-self: center;
    `}


`;

export const Banner = styled.div<{ reverse?: boolean, theme?: ColorTheme, center?: boolean, leadWithImage?: boolean }>`
    display: flex;
    flex-grow: 1;
    flex-direction: ${(p) => p.reverse ? 'row-reverse' : 'row'};
    z-index: 1;

    @media screen and (max-width: 900px) {
        flex-direction: ${(p) => (p.leadWithImage) ? 'column-reverse' : 'column'};

        ${Content} {
            width: 100%;
            justify-content: space-around !important;
        }

        ${Container} {
            max-width: 600px;
        }
    }

    ${(p) => getTheme(p.theme)};

    ${(p) => p.center && css`
        align-items: center;  
    `}

    ${Content}:nth-child(even) {
        article {
            align-self: end;
        }

        h2 {
            max-width: 600px;
            align-self: end;
            width: 100%;
        }
    }
`;

export const LeftContent = styled(Content)`
    justify-content: end;
`;

export const RightContent = styled(Content)`
    justify-content: start;
`;

export const Warning = styled.div`
    background-color: ${Colors.red};
    color: ${Colors.trueWhite};
    padding: 20px;
    text-align: center;
    font-size: 40px;
`;
